import React from 'react';
import "./Footer.css";

export default function Footer() {
  return (
    <>
      <footer className="footer">
        <div className="footer-inner">
          <p>&copy; {new Date().getFullYear()} Ian Whitesel</p>
          <div className="footer-links">
            <a href="https://github.com/altoc" target="_blank" rel="noopener noreferrer">
              GitHub
            </a>
            <a href="https://www.linkedin.com/in/ian-whitesel/" target="_blank" rel="noopener noreferrer">
              LinkedIn
            </a>
            <a href="https://altoc.itch.io/" target="_blank" rel="noopener noreferrer">
              Itch.io
            </a>
            <a href="mailto:ianwhitesel97@gmail.com">ianwhitesel97@gmail.com</a>
          </div>
        </div>
      </footer>
    </>
  );
}
